import { ctaStripStep } from './steps/ctaStrip'
import { dynamicHeroStep } from './steps/dynamicHeroStep'
import { removeRecommendationsForCustomerStep } from './steps/recommendationsforCustomerStep'

const defaultSteps = [dynamicHeroStep]

const controlLoggedOutSteps = [
  ...defaultSteps,
  removeRecommendationsForCustomerStep,
]

const controlLoggedInSteps = [...defaultSteps]

export const getPipelineSteps = ({
  loggedIn,
}: {
  loggedIn: boolean | null
  region: string
}) => {
  return loggedIn
    ? [...controlLoggedInSteps, ctaStripStep]
    : [...controlLoggedOutSteps, ctaStripStep]
}
